// Each section owns one bounded request lifecycle, including in the theme editor.
(function () {
  'use strict';
  var sections = new WeakMap();
  function findSections(target) {
    var found = Array.from(target.querySelectorAll('.dynamic-recommendation-section'));
    if (target.matches && target.matches('.dynamic-recommendation-section')) found.unshift(target);
    return found;
  }
  async function load(section) {
    if (sections.has(section)) return;
    var grid = section.querySelector('.grid-container-wrapper');
    var url = (section.dataset.url || '').trim();
    if (!grid || !url) return;
    var controller = new AbortController();
    var state = { controller: controller, slider: null };
    sections.set(section, state);
    section.classList.add('d-none');
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    async function request(url, format) {
      var response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Recommendations request failed');
      return response[format]();
    }
    try {
      var data = await request(url, 'json');
      var products = Array.isArray(data.products) ? data.products : [];
      var results = await Promise.allSettled(products.map(function (product) {
        return request((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'products/' + encodeURIComponent(product.handle) + '?view=recommended-product', 'text');
      }));
      if (controller.signal.aborted || !section.isConnected) return;
      var loaded = [];
      results.forEach(function (result, index) {
        if (result.status === 'fulfilled' && result.value.trim()) {
          var template = document.createElement('template');
          template.innerHTML = result.value;
          if (!template.content.querySelector('.rec-products')) return;
          grid.appendChild(template.content);
          loaded.push(products[index]);
        }
      });
      if (!loaded.length) return;
      grid.classList.toggle('w-100', loaded.length < 3);
      var ratio = section.dataset.imageratio;
      if (ratio) grid.querySelectorAll('img').forEach(function (image) { image.classList.add(ratio); });
      section.classList.remove('d-none');
      if (typeof tns === 'function') state.slider = sliderRecommendedProducts(grid.dataset.sectionid, grid);
      document.dispatchEvent(new CustomEvent('shopify-recommendation:init-product-grid', { detail: { recommendations: loaded } }));
    } catch (error) {
      // An optional recommendation failure must not break product or cart controls.
      if (!controller.signal.aborted) console.warn('Recommendations unavailable:', error.message);
    } finally {
      clearTimeout(timeout);
    }
  }
  function initialize(target) { findSections(target).forEach(load); }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    findSections(event.target).forEach(function (section) {
      var state = sections.get(section);
      if (!state) return;
      state.controller.abort();
      if (state.slider && state.slider.destroy) state.slider.destroy();
      sections.delete(section);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
})();
// recommended products slider
function sliderRecommendedProducts(sectionId,productRecomendationBody) {
  //row formatting
  var element = productRecomendationBody;
  //element.classList.remove('row');

  var slider2 = tns({
      container: productRecomendationBody,
      items: 1,
      slideBy: 1,
      nav: false,
      speed: 400,
      mode: 'carousel',
      prevButton: '#'+sectionId+' .js-slider-sites-prev',
      nextButton: '#'+sectionId+' .js-slider-sites-next',
      autoplayButtonOutput: false,
      mouseDrag: true,
      autoplay: false,
      controls: true,
      freezable: true,
      touch: true,
      preventScrollOnTouch: 'auto',
      navPosition: 'bottom',
      rewind: true,
      lazyload: true,
      center: false,
      loop: false,
      controlsContainer: '#'+sectionId+' .recommendations-slider-controls',
      responsive: {
        480: {
          items: 1,
        },
        640: {
          items: 2,
        },
        768: {
          items: 3,
        }
      }
    });
    slider2.refresh();
    return slider2;
}
